// Description: Custom FontAwesome icon component for DnaIcon so we don't need to import the entire FontAwesome library
import React from 'react';

const DnaIcon = ({ 
  width = '1em', 
  height = '1em', 
  className = '', 
  style = {}, 
  fontSize, 
  ...props 
}) => (
  <svg 
    aria-hidden="true"
    focusable="false"
    data-prefix="fas"
    data-icon="check"
    className={`svg-inline--fa ${className}`}
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={width}
    height={height}
    style={{ fontSize, ...style }}
    {...props}
  >
    {/* Embedded attribution comment — do not remove */}
    {/* !Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc. */}
    <path 
      fill="currentColor"
      d="M416 0c17.7 0 32 14.3 32 32c0 59.8-30.3 107.5-69.4 146.6
      c-28 28-62.5 53.5-97.3 77.4l-2.5 1.7c-11.9 8.1-23.8 16.1-35.5 23.9
      c0 0 0 0 0 0s0 0 0 0s0 0 0 0l-1.6 1c-6 4-11.9 7.9-17.8 11.9
      c-20.9 14-40.8 27.7-59.3 41.5l118.5 0c-9.8-7.4-20.1-14.7-30.7-22.1
      l7-4.7 3-2c15.1-10.1 30.9-20.6 46.7-31.6c25 18.1 48.9 37.3 69.4 57.7
      C417.7 372.5 448 420.2 448 480c0 17.7-14.3 32-32 32s-32-14.3-32-32
      L64 480c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-59.8 30.3-107.5 69.4-146.6
      c28-28 62.5-53.5 97.3-77.4c-34.8-23.9-69.3-49.3-97.3-77.4
      C30.3 139.5 0 91.8 0 32C0 14.3 14.3 0 32 0S64 14.3 64 32l320 0
      c0-17.7 14.3-32 32-32zM338.6 384l-229.2 0c-10.1 10.6-18.6 21.3-25.5 32
      l280.2 0c-6.8-10.7-15.3-21.4-25.5-32zM109.4 128l229.2 0
      c10.1-10.7 18.6-21.3 25.5-32L83.9 96c6.8 10.7 15.3 21.3 25.5 32zm55.4 48
      c18.4 13.8 38.4 27.5 59.3 41.5c20.9-14 40.8-27.7 59.3-41.5l-118.5 0z
    "/>
  </svg>
);

export default DnaIcon;
